import React from 'react'
import CartContext from '../contexts/CartContext'

export default function useCart () {
  const cart = React.useContext(CartContext)

  if (cart === null) {
    throw new Error('Tried to use cart, but got NULL (default value). Has it been provided?')
  }

  return cart
}
